/**
 * Copied from:
 * https://github.com/Source-Digital/experience-engine/blob/f1414a0be3a36df93048cabb9c685160a4a873bf/front/src/utils/load-js-script.ts#L3
 * TODO move to a shared package
 */

const promises = new Map<string, Promise<any>>()

/**
 *  Taking idea from
 * https://markus.oberlehner.net/blog/distributed-vue-applications-loading-components-via-http/
 */
export default async function loadJsScript<T = any> (url: string, globalName: string): Promise<T> {
  if (url == null) throw new Error('url must be specified.')

  if (promises.has(globalName)) return await promises.get(globalName)

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.addEventListener('load', () => {
      // @ts-expect-error
      const module = window[globalName]
      resolve(module)
    })
    script.addEventListener('error', () => {
      reject(new Error(`Error loading ${url}`))
    })
    script.src = url
    document.head.appendChild(script)
  })
  promises.set(globalName, promise)

  return await promises.get(globalName)
}
